import React from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../../router/Routes';
import ContainerTemplate from '../../../widgets/template/Container';
import { PARAMS_JUGADORES } from './JugadoresReducer';
import JugadoresView from './JugadoresView';

const JugadoresModule = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const jugadoresStore = Redux.useSelector((state) => state.jugadores);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...jugadoresStore.params,
        idEntidad: entidadesStore.activo.id,
        idEquipo: null,
      };
      dispatch({ type: PARAMS_JUGADORES, payload });
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ContainerTemplate
      active={ROUTES.jugadores}
      routes={[ROUTES.juegosDeportivos]}
    >
      <JugadoresView isCreate={false} isEdit={false} />
    </ContainerTemplate>
  );
};

export default JugadoresModule;
